import SkeletonTable from "@/components/SkeletonTable";
import { getListPesertaVerifikasiSkl } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { AlertCircle, FileSearch } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import ValidationDashboard from "./partial/ValidationDashboard";
import { useUser } from "@/hooks/useUser";

export default function VerifikasiSklPesertaPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page") || "";
  const rowsPerPageParams = searchParams.get("rowsPerPage") || "";
  const searchQueryParams = searchParams.get("search") || "";
  const statusValidasiParams = searchParams.get("statusValidasi") || "";
  const ukIdsParams = searchParams.get("uk_ids") || "";

  const { user } = useUser();
  const isVerifikatorAll = user?.jenis_user?.includes("verifikator_skl_all");
  const jenisVerifikatorParams = isVerifikatorAll ? "all" : "";

  const { data, isPending, isError } = useQuery({
    queryKey: [
      "listPesertaVerifikasiSkl",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      statusValidasiParams,
      ukIdsParams,
      jenisVerifikatorParams,
    ],
    queryFn: () =>
      getListPesertaVerifikasiSkl(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        statusValidasiParams as string,
        ukIdsParams as string,
        jenisVerifikatorParams as string,
      ),
  });

  const { data: dataAll } = useQuery({
    queryKey: ["listPesertaVerifikasiSklAll"],
    queryFn: () =>
      getListPesertaVerifikasiSkl(
        undefined,
        "99999",
        undefined,
        undefined,
        undefined,
        jenisVerifikatorParams as string,
      ),
  });

  return (
    <div className="flex flex-col h-full min-h-screen bg-background dark:bg-[#09090b] text-foreground p-4 md:p-6 transition-colors duration-200">
      <ValidationDashboard data={dataAll?.data} />
      {/* HEADER HALAMAN */}
      <div className="mb-6 flex flex-col gap-1">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-3">
          <div className="p-2.5 bg-primary/10 text-primary rounded-xl">
            <FileSearch className="w-6 h-6" />
          </div>
          Daftar Peserta Verifikasi SKL
        </h1>
        <p className="text-sm text-muted-foreground max-w-2xl">
          Tinjau, kelola, dan lakukan validasi terhadap dokumen Surat Keterangan
          Lulus (SKL) yang diunggah oleh pendaftar.
        </p>
      </div>

      {/* AREA KONTEN (Tabel / Skeleton / Error) */}
      <div className="flex-1 w-full">
        {isPending ? (
          <div className="rounded-xl border border-border dark:border-zinc-800 bg-card overflow-hidden">
            {/* Jika Anda sudah mengupdate DataTable untuk menerima props isLoading, 
                 Anda bisa langsung memanggil <DataTable isLoading={true} ... /> di sini.
                 Namun jika belum, panggil SkeletonTable bawaan Anda: */}
            <SkeletonTable />
          </div>
        ) : isError ? (
          <div className="flex flex-col items-center justify-center h-[400px] rounded-xl border border-destructive/20 bg-destructive/5 dark:bg-destructive/10 text-destructive dark:text-red-400">
            <AlertCircle className="h-10 w-10 mb-3 opacity-80" />
            <h3 className="text-lg font-semibold">Gagal Memuat Data</h3>
            <p className="text-sm opacity-80">
              Terjadi kesalahan pada server atau jaringan Anda. Silakan coba
              beberapa saat lagi.
            </p>
          </div>
        ) : (
          <DataTable
            data={data?.data || []}
            paginationData={data}
            columns={columns}
          />
        )}
      </div>
    </div>
  );
}
